module.exports = __webpack_public_path__ + "img/own-production.9e74f0de.png";